import moment from 'moment';
import { ThunkAction } from 'redux-thunk';
import { IAction } from '../interfaces/IAction';
import { MEMBER_SEARCH_SCREEN } from 'redhotpie-shared-lib/constants/category';
import memberSearchService from 'redhotpie-shared-lib/services/memberSearchService';
import * as types from '../constants/actionTypes';
import {
  CHAT_TYPES,
  EVENT_SELECTION_TYPE,
  MEMBER_ROLE,
  PAGING_DEFAULT,
  REASON_INVITE_USER_TO_GROUP,
  USER_NOT_MATCHED,
} from '../constants/constants';
import { TYPE_LEAVE_GROUP_CHAT } from '../constants/messageTypes';
import { TYPE_INVITE, TYPE_MESSAGE } from '../constants/notificationTypes';
import { sentGroupMessageNotify } from '../functions/messageUtils';
import {
  createFormDataComment,
  generateParamsClubSearch,
  generateParamsCreateEvent,
  generateParamsEventSearch,
  generateParamsMemberSearch,
  genereateParamsPostCommentReply,
  hasOwnProperty,
} from '../functions/utils';
import WebIM from '../libs/webIM';
import WebIMConfig from '../libs/webIMConfig';
import commentSystemServices from '../services/commentSystemService';
import conversationService from '../services/conversationService';
import eventService from '../services/eventService';
import * as GoogleService from '../services/googleService';
import userService from '../services/userService';
import * as myStore from '../store/myStore';
import { getStore } from '../store/myStore';
import {
  getOrCreateConversation,
  joinPrivateGroup,
  notifyMessageSent,
  removeRoomJidInJoinedSuccessRoomJids,
  updateParticipantCount,
  updateServerTimeGroupChat,
} from './conversationInboxAction';
import * as conversationInboxAction from './conversationInboxAction';
import {
  removeMessageByRoomJid,
  removeMessageShareEventTicket,
  sendInviteGroupChatMessage,
  sendLeaveGroupMessage,
  sendRemovedFromGroupMessage,
  sendShareEventMessage,
} from './messageActions';
import { createUserInvite, getMainPhotos } from './userActions';
import { updateGroupEventSuccess } from './groupActions';
import Conversation from 'redhotpie-shared-lib/models/conversation';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

export type ThunkResult<R> = ThunkAction<R, any, undefined, IAction>;

export function deleteAllUserEventInterestGroupChatSuccess(eventId: any): IAction {
  return { type: types.DELETE_ALL_USER_EVENT_GROUP_CHAT, eventId };
}

export function showOrHiddenTicketLinkSuccess(params: any): IAction {
  return { type: types.POST_SHOW_HIDDEN_TICKET_LINK, params };
}

export function inviteOrRemoveGroupChatSuccess(params: any): IAction {
  return { type: types.POST_INVITE_REMOVE_GROUP_CHAT, params };
}

export function getEventCategorySuccess(data: any): IAction {
  return { type: types.GET_EVENT_CATEGORY_SUCCESS, data };
}

export function getClubCategorySuccess(data: any): IAction {
  return { type: types.GET_CLUB_CATEGORY_SUCCESS, data };
}

export function getEventSearchSuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_SEARCH_SUCCESS, data, params };
}

export function getEventInterestedSuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_INTERESTED_SUCCESS, data, params };
}

export function getEventSearchSponsoredSuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_SEARCH_SPONSORED_SUCCESS, data, params };
}

export function getUserEventsSuccess(data: any, params: any): IAction {
  return { type: types.GET_USER_EVENT_SUCCESS, data, params };
}

export function getShareMyEventsSuccess(data: any, params: any): IAction {
  return { type: types.GET_SHARE_MY_EVENT_SUCCESS, data, params };
}

export function getClubSearchSuccess(data: any, params: any): IAction {
  return { type: types.GET_CLUB_EVENT_SUCCESS, data, params };
}

export function getEventOfUserSuccess(data: any): IAction {
  return { type: types.GET_MY_USER_EVENT_SUCCESS, data };
}

export function getUserEventInterestSuccess(data: any, params: any): IAction {
  return { type: types.GET_USER_INTEREST_EVENT_SUCCESS, data, params };
}

export function getEventInterestSuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_INTEREST_SUCCESS, data, params };
}

export function deleteEventInterestSuccess(id: any): IAction {
  return { type: types.DELETE_EVENT_INTEREST_SUCCESS, id };
}

export function getEventCommentSuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_COMMENT_SUCCESS, data, params };
}

export function getEventClubSuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_CLUB_SUCCESS, data, params };
}

export function getEventDetailSuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_DETAIL_SUCCESS, data, params };
}

export function postCreateEventSuccess(data: any, params: any): IAction {
  return { type: types.POST_CREATE_EVENT_SUCCESS, data, params };
}

export function postCreateEventInterestSuccess(params: any): IAction {
  return { type: types.POST_CREATE_EVENT_INTEREST_SUCCESS, params };
}

export function postCreateEventCommentSuccess(data: any, params: any): IAction {
  return { type: types.POST_CREATE_EVENT_COMMENT_SUCCESS, data, params };
}

export function deleteCommentSuccess(commentId: any): IAction {
  return { type: types.DELETE_EVENT_COMMENT_SUCCESS, commentId };
}

export function patchDeleteEventSuccess(params: any): IAction {
  return { type: types.PATCH_DELETE_EVENT_SUCCESS, params };
}

export function patchDeleteInterestSuccess(params: any): IAction {
  return { type: types.PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS, params };
}

export function patchDeleteUserInterestSuccess(params: any): IAction {
  return { type: types.PATCH_DELETE_USER_EVENT_INTERESTED_SUCCESS, params };
}

export function patchUpdateMyEventSuccess(data: any, index: any): IAction {
  return { type: types.PATCH_UPDATE_MY_USER_EVENT_SUCCESS, data, index };
}

export function mergeDataEvent(data: any): IAction {
  return { type: types.MERGE_DATA_EVENT_SUCCESS, data };
}

export function requestGetDetailClubEvent(data: any): IAction {
  return { type: types.REQUEST_GET_DETAIL_CLUB_EVENT, data };
}

export function closeClubDetail(): IAction {
  return { type: types.CLOSE_CLUB_DETAIL };
}

export function getDetailClubSuccess(data: any): IAction {
  return { type: types.GET_DETAIL_CLUB_EVENT_SUCCESS, data };
}

export function getPhotoClubSuccess(data: any): IAction {
  return { type: types.GET_PHOTO_DETAIL_CLUB_SUCCESS, data };
}

export function getDetailClubFail(data: any): IAction {
  return { type: types.GET_DETAIL_CLUB_EVENT_FAIL, data };
}

export function updateStateEventHome(dataKey: any, data: any): IAction {
  return { type: types.UPDATE_STATE_EVENT_HOME, dataKey, data };
}

export function setStateEntitiesTabIndex({ categoryId, index, flag }: any): IAction {
  return { type: types.SET_STATE_ENTITIES_TYPE_GUEST, categoryId, index, flag };
}

export function getEventReplySuccess(data: any, params: any): IAction {
  return { type: types.GET_EVENT_REPLY_SUCCESS, data, params };
}

export function getEventReplyForShowLessShowMore(params: any): IAction {
  return { type: types.GET_EVENT_REPLY_SHOW_MORE_SHOW_LESS, params };
}

export function getEventPopularCountSuccess(data: any, googleMapPlaceID: any): IAction {
  return {
    type: types.GET_EVENT_POPULAR_COUNT_SUCCESS,
    data,
    googleMapPlaceID,
  };
}

export function getClubCountSuccess(data: any, googleMapPlaceID: any): IAction {
  return { type: types.GET_CLUB_COUNT_SUCCESS, data, googleMapPlaceID };
}

export function postCreateCommentLikeSuccess(data: any): IAction {
  return { type: types.POST_CREATE_COMMENT_LIKE_SUCCESS, data };
}

export function deleteCommentLikeSuccess(data: any): IAction {
  return { type: types.DELETE_COMMENT_LIKE_SUCCESS, data };
}

export function getClubEventsSuccess(params: any, data: any, total: any): IAction {
  return { type: types.GET_CLUB_EVT_SUCCESS, params, data, total };
}

export function updateStateEventDetail(data: any): IAction {
  return { type: types.UPDATE_STATE_EVENT_DETAIL, data };
}

export function updateUserPhotoGroupChat(data: any, index: any): IAction {
  return { type: types.UPDATE_USER_PHOTO_GROUP_CHAT, data, index };
}

export function deleteEventInterestByOwnerSuccess(params: any): IAction {
  return { type: types.DELETE_EVENT_INTEREST_BY_OWNER_SUCCESS, params };
}

export function mergeDataFilterInterested(params: any): IAction {
  return { type: types.MERGE_FILTER_INTERESTED, params };
}

/**
 * @param {{dataKey: string[], value: *}} params
 * @returns
 */
export function updateStateGroupChat(params: { dataKey: string[]; value: any }): IAction {
  return { type: types.UPDATE_STATE_GROUP_CHAT, params };
}

export function endGroupChatSuccess(params: any): IAction {
  return { type: types.END_GROUP_CHAT_SUCCESS, params };
}

export function getEventSearch(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  // categoryId: -1,
  // dateStart: null,
  // dateEnd: null,
  // location: {
  //      GoogleMapPlacesId:''
  // },
  // searchRadius: 100,
  // sponsoredType: "All", // SponsoredType  Accepted values are All, NonSponsored, Sponsored
  // featuredType: "All" // FeaturedType Accepted values are All, NonFeatured, Featured
  return dispatch => {
    if (!params.sponsoredType) {
      dispatch(
        mergeDataEvent({
          isLoadingEventNonSponsored: !params.isLoadMore,
        })
      );
    } else {
      // dispatch(mergeDataEvent({
      //     isLoadingEventSearch: !params.isLoadMore,
      //     pageNumberEventSearch: params && params.page ? params.page : 1
      // }));
    }
    return eventService.getEventSearch(generateParamsEventSearch(params)).then((res: any) => {
      if (res.success) {
        if (!params.searchTerm || params?.searchTerm?.length === 0) {
          dispatch(getEventSearchSuccess(res.data, params));
        } else {
          dispatch(
            mergeDataEvent({
              isLoadingEventSearch: false,
              isLoadingEventNonSponsored: false,
            })
          );
        }
      } else {
        dispatch(
          mergeDataEvent({
            isLoadingEventSearch: false,
            isLoadingEventNonSponsored: false,
          })
        );
        console.log('ERROR: eventHomeAction/getEventSearch', res.message);
      }
      return res;
    });
  };
}

/**
 *
 * @param params:
 *  isLoadMore: used to get more
 *  refer to generateParamsClubSearch
 * @returns {function(*): *}
 */
export function getClubSearch(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingClubEvents: true,
        pageClubSearch: params && params.page ? params.page : 1,
      })
    );
    return eventService.getClubSearch(generateParamsClubSearch(params)).then((res: any) => {
      if (res.success) {
        dispatch(getClubSearchSuccess(res.data.data, params));
      } else {
        dispatch(
          mergeDataEvent({
            isLoadingClubEvents: false,
            isLoadedDataClubEvents: true,
            hasMoreClubData: false,
          })
        );
        console.log('ERROR: eventHomeAction/getClubSearch', res.message);
      }
      return res;
    });
  };
}

export function getDetailClub(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(requestGetDetailClubEvent({ isLoadingDetailClubEvents: true }));
    return eventService.getDetailClub(params).then((res: any) => {
      // console.log("res data", res);
      if (res.success) {
        dispatch(getDetailClubSuccess(res.data.data));
      } else {
        dispatch(getDetailClubFail({ isLoadingDetailClubEvents: false }));
        dispatch(mergeDataEvent({ dataDetailClub: { clubNotFound: true } }));
        console.log('ERROR: eventHomeAction/getClubSearch', res.message);
      }
      return res;
    });
  };
}

export function getPhotoDetailClub(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    // dispatch(requestGetDetailClubEvent({isLoadingDetailClubEvents: true}));
    return eventService.getPhotoDetailClub(params).then((res: any) => {
      if (res.success) {
        dispatch(getPhotoClubSuccess(res.data.data));
      } else {
        dispatch(getPhotoClubSuccess([]));
        console.log('ERROR: eventHomeAction/getClubSearch', res.message);
      }
      return res;
    });
  };
}

export function getEventSearchSponsored(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    if (params.sponsoredType === 'Sponsored') {
      dispatch(
        mergeDataEvent({
          isLoadingEventSearchSponsored: true,
        })
      );
    }
    if (!params.sponsoredType) {
      dispatch(
        mergeDataEvent({
          isLoadingEventSearch: true,
        })
      );
    }
    return eventService.getEventSearch(generateParamsEventSearch(params)).then((res: any) => {
      if (res.success) {
        dispatch(getEventSearchSponsoredSuccess(res.data, params));
      } else {
        if (params.sponsoredType === 'Sponsored') {
          dispatch(
            mergeDataEvent({
              isLoadingEventSearchSponsored: false,
              isCalledEventSearchSponsoredAPI: true,
            })
          );
        }
        if (!params.sponsoredType) {
          dispatch(
            mergeDataEvent({
              isLoadingEventSearch: false,
              isCalledEventSearchAPI: true,
            })
          );
        }
        dispatch(getEventSearchSponsoredSuccess({ data: [] }, params));
        console.log('ERROR: eventHomeAction/getEventSearch', res.message);
      }
      return res;
    });
  };
}

export function getUserEvents(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingUserEvents: true,
        pageNumberUserEvents: params && params.page ? params.page : 1,
        isLoadMore: params?.isLoadMore || false,
      })
    );
    return eventService.getUserEvents(params).then((res: any) => {
      if (res.success) {
        dispatch(getUserEventsSuccess(res.data, params));
      } else {
        console.log('ERROR: eventHomeAction/getUserEvents', res.message);
      }
      return res;
    });
  };
}

export function getShareMyEvents(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMoreShareMyEvents to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingShareMyEvents: true,
        pageNumberShareMyEvents: params && params.page ? params.page : 1,
        isLoadMoreShareMyEvents: params?.isLoadMore || false,
      })
    );
    return eventService.getUserEvents(params).then((res: any) => {
      if (res.success) {
        dispatch(getShareMyEventsSuccess(res.data, params));
      } else {
        console.log('ERROR: eventHomeAction/getUserEvents', res.message);
      }
      return res;
    });
  };
}

export function getEventOfUser(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingEventOfUser: true,
      })
    );
    return eventService.getEventOfUser(params).then((res: any) => {
      if (res.success) {
        dispatch(getEventOfUserSuccess(res.data));
      } else {
        console.log('ERROR: eventHomeAction/getEventOfUser', res.message);
      }
      return res;
    });
  };
}

export function getUserEventInterest(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingUserEventInterest: true,
        pageNumberUserEventInterest: params && params.page ? params.page : 1,
        isLoadMore: params.isLoadMore || false,
      })
    );
    return eventService.getUserEventInterest(params).then((res: any) => {
      // console.log('getUserEventInterest', res);
      if (res.success) {
        dispatch(getUserEventInterestSuccess(res.data, params));
      } else {
        console.log('ERROR: eventHomeAction/getUserEventInterest', res.message);
      }
      return res;
    });
  };
}

export function getEventInterest(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingEventInterest: true,
        pageNumberEventInterest: params && params.page ? params.page : 1,
        isLoadMore: params.isLoadMore || false,
        filterHasChange: false,
      })
    );
    return eventService.getEventInterest(params).then((res: any) => {
      if (res.success) {
        dispatch(getEventInterestSuccess(res.data, params));
      } else {
        console.log('ERROR: eventAction/getEventInterest', res.message);
      }
      return res;
    });
  };
}

export function deleteEventInterest(id: any): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(deleteEventInterestSuccess(id));
    return eventService.deleteEventInterest(id).then((res: any) => {
      if (res.success) {
        // Do not thing
      } else {
        console.log('ERROR: eventAction/deleteEventInterest', res.message);
      }
      return res;
    });
  };
}

export function getEventComment(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingEventComment: true,
        pageNumberEventComment: params && params.page ? params.page : 1,
        // dataEventComment: []
      })
    );
    return eventService.getEventComment(params).then((res: any) => {
      // console.log(res)
      if (res.success) {
        dispatch(getEventCommentSuccess(res.data, params));
      } else {
        console.log('ERROR: eventHomeAction/getEventComment', res.message);
      }
      return res;
    });
  };
}

export function getEventReply(params: any): ThunkResult<Promise<any>> {
  // @params
  // size,
  // data: list comment
  //
  const listID: any[] = [];
  if (params.data && params.data.length) {
    params.data.forEach((item: any) => {
      listID.push(item.commentId);
    });
  }
  const body = {
    ...params,
    listCommentId: listID.toString(),
  };
  // console.log(listID)
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingEventReply: true,
      })
    );
    return commentSystemServices.getReply(body).then((res: any) => {
      //  console.log(res)
      if (res.success) {
        dispatch(getEventReplySuccess(res.data, { size: params.size }));
      } else {
        console.log('ERROR: eventHomeAction/getEventReply', res.message);
      }
      return res;
    });
  };
}

export function getEventReplyFull(params: any): ThunkResult<Promise<any>> {
  // @params
  // commentParentID : comment parent ID
  // pageSize:
  // page
  // index: parent
  return (dispatch, getState) => {
    const { dataEventCommentTmp } = getState().eventReducer;
    if (dataEventCommentTmp[params.index] && !dataEventCommentTmp[params.index].isHasMoreReply) {
      dispatch(getEventReplyForShowLessShowMore(params));
      return Promise.resolve({ success: true });
    }
    return commentSystemServices.getReplyFull(params).then((res: any) => {
      console.log('getReplyFull', params, res);
      if (res.success) {
        dispatch(getEventReplySuccess(res.data, params));
      } else {
        console.log('ERROR: eventHomeAction/getEventReplyFull', res.message);
      }
      return res;
    });
  };
}

export function getEventClub(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingAlert: true,
        pageNumberAlert: params && params.page ? params.page : 1,
      })
    );
    return eventService.getEventClub(params).then((res: any) => {
      if (res.success) {
        dispatch(getEventClubSuccess(res.data, params));
      } else {
        console.log('ERROR: eventHomeAction/getEventClub', res.message);
      }
      return res;
    });
  };
}

export function getEventDetail(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    const { dataDetailEvent } = myStore.getStore().getState().eventReducer;
    let mergeData: any = {
      eventError: false,
    };
    if (dataDetailEvent?.detail?.eventId === Number.parseInt(params.ID)) {
      console.log('The same event');
    } else {
      mergeData = {
        ...mergeData,
        isLoadingEventDetail: true,
        dataDetailEvent: {},
        dataEventComment: [],
      };
    }
    dispatch(mergeDataEvent(mergeData));

    return eventService.getEventDetail(params).then((res: any) => {
      if (res.success) {
        dispatch(getEventDetailSuccess(res.data, params));
      } else {
        dispatch(
          mergeDataEvent({
            isLoadingEventDetail: false,
            dataDetailEvent: {},
            eventError: true,
          })
        );
        console.log('ERROR: eventHomeAction/getEventDetail', res.message);
      }
      return res;
    });
  };
}

export function postCreateEvent(params: any, clubId: any, additionalDateHelds: string[] = []): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingCreateEvent: true,
      })
    );
    return eventService.postCreateEvent(generateParamsCreateEvent(params), clubId, additionalDateHelds).then((res: any) => {
      if (res.success) {
        // dispatch(postCreateEventSuccess(eventUser.mappingObjectsCustomMember(res.data.items), params));
      } else {
        console.log('ERROR: eventHomeAction/postCreateEvent', res.message);
      }
      return res;
    });
  };
}

export function postCreateEventInterest(params: any) {
  // Params: isLoadMore to check user have load more yet
  return (dispatch: any) => {
    dispatch(postCreateEventInterestSuccess(params));
    return eventService.postCreateEventInterest(params).then(res => {
      if (res.success) {
        if (res.data !== USER_NOT_MATCHED) {
        }
        // console.log("res register", res);
      } else {
        console.log('ERROR: eventHomeAction/postCreateEventInterest', res.message);
      }
      return res;
    });
  };
}

export function postCreateEventComment(params: any): ThunkResult<Promise<any>> {
  // Params: isLoadMore to check user have load more yet
  // params : {
  //   id: detail.eventId,
  //   commentParentID:null,
  //   subject:'',
  //   message: text
  // }
  let body = genereateParamsPostCommentReply(params);
  body = createFormDataComment(params, body);
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingAlert: true,
      })
    );
    return eventService.postCreateEventComment(body, { ID: params.id }).then((res: any) => {
      if (res.success) {
        dispatch(postCreateEventCommentSuccess(res.data, params));
      } else {
        console.log('ERROR: eventHomeAction/postCreateEventComment', res.message);
      }
      return res;
    });
  };
}

export function deleteComment(commentId: any): ThunkResult<Promise<any>> {
  return dispatch => {
    // dispatch(mergeDataEvent({
    //     isLoadingAlert: true,
    // }));
    dispatch(deleteCommentSuccess(commentId));
    return commentSystemServices.deleteComment(commentId).then((res: any) => {
      if (res.success) {
        // delete comment success
      } else {
        console.log('ERROR: eventHomeAction/deleteComment', res.message);
      }
      return res;
    });
  };
}

export function patchDeleteEvent(params: any): ThunkResult<Promise<IApiResponse>> {
  return dispatch => {
    // eventId: '12345' List of Event IDs that the action will be applied to
    return eventService.patchDeleteEvent(params).then((res: any) => {
      if (!res.success) {
        console.log('ERROR: eventHomeAction/patchDeleteEvent', res.message);
      } else {
        dispatch(patchDeleteEventSuccess(params));
      }
      return res;
    });
  };
}

export function patchDeleteInterest(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    // index: Index of item which selected to Approve/Reject
    // ID the ID of the DateFinder Date
    // ListID List of DateFinder Interest IDs that the action will be applied to
    // Action Action to be applied to the above Interets list, must be Approve or Delete
    // params example {index: 0, ID: 34524, ListID: 12345, Action: Approve/Delete}
    if (params) {
      dispatch(patchDeleteInterestSuccess(params));
    }
    return eventService.patchDeleteInterest(params).then((res: any) => {
      if (!res.success) {
        console.log('ERROR: eventHomeAction/patchDeleteInterest', res.message);
      } else {
        const { paramsForInterested } = myStore.getStore().getState().eventReducer;
        if (paramsForInterested) {
          dispatch(getEventInterested(paramsForInterested));
        }
      }
      return res;
    });
  };
}

export function patchDeleteUserEventInterest(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    if (params) {
      dispatch(patchDeleteUserInterestSuccess(params));
    }
    return eventService.patchDeleteUserInterest(params).then((res: any) => {
      if (!res.success) {
        console.log('ERROR: eventActions/patchDeleteUserEventInterest', res.message);
      }
      return res;
    });
  };
}

export function getEventCategory(): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService.getEventCategory().then((res: any) => {
      if (res && res.success) {
        dispatch(getEventCategorySuccess(res.data));
      }
    });
  };
}

export function getClubCategory(): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService.getClubCategory().then((res: any) => {
      if (res && res.success) {
        dispatch(getClubCategorySuccess(res.data));
      }
    });
  };
}

export function getEventPopularCount(googleMapPlaceID?: any): ThunkResult<Promise<any>> {
  const placeId = googleMapPlaceID || null;
  return dispatch => {
    return eventService.getEventPopularCount(placeId).then((res: any) => {
      if (res.success) {
        dispatch(getEventPopularCountSuccess(res.data, placeId));
      } else {
        console.log('Error: eventActions/getEventPopularCount', res.message);
      }
      return res;
    });
  };
}

export function getClubCount(googleMapPlaceID?: any): ThunkResult<Promise<any>> {
  const placeId = googleMapPlaceID || null;
  return dispatch => {
    return eventService.getClubCount(placeId).then((res: any) => {
      if (res.success) {
        dispatch(getClubCountSuccess(res.data, placeId));
      } else {
        console.log('Error: eventActions/getClubCount', res.message);
      }
      return res;
    });
  };
}

export function patchUpdateMyEvent(params: any, index: any, clubId: any): ThunkResult<Promise<any>> {
  return dispatch => {
    // console.log(generateParamsCreateEvent(params));
    return eventService.patchUpdateMyEvent(generateParamsCreateEvent(params), clubId).then((res: any) => {
      if (res.success) {
        dispatch(patchUpdateMyEventSuccess(res.data, index));

        if (clubId) {
          const isEventInThePast = moment(params.dateHeld).isBefore(moment());
          // dispatch(getClubCount(clubId));
          dispatch(updateGroupEventSuccess(params, isEventInThePast));
        }
      } else {
        console.log('ERROR: eventHomeAction/patchDeleteInterest', res.message);
      }
      return res;
    });
  };
}

export function getPlaceDetailAndCountryFromGeoLocation(lat: any, lng: any): ThunkResult<Promise<any>> {
  return () => {
    return GoogleService.getPlaceDetailAndCountryFromGeoLocation(lat, lng).then((res: any) => {
      if (res.success) {
        console.log('Success: memberSearchActions/getPlaceDetailFromGeoLocation');
      } else {
        console.log('Error: memberSearchActions/getPlaceDetailFromGeoLocation', res.message);
      }
      return res;
    });
  };
}

export function postCreateCommentLike(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(postCreateCommentLikeSuccess(params));
    return commentSystemServices.postCreateCommentLike(params).then((res: any) => {
      if (res.success) {
        // dispatch(postCreateCommentLikeSuccess(params));
      } else {
        console.log('ERROR: eventHomeAction/postCreateCommentLike', res.message);
      }
      return res;
    });
  };
}

export function deleteCommentLike(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(deleteCommentLikeSuccess(params));
    return commentSystemServices.deleteCommentLike(params).then((res: any) => {
      if (res.success) {
        // dispatch(deleteCommentLikeSuccess(params));
      } else {
        console.log('ERROR: eventHomeAction/deleteCommentLike', res.message);
      }
      return res;
    });
  };
}

export function toggleCreateEditEventDesktopModal(status: any): IAction {
  return { type: types.TOGGLE_CREATE_EDIT_EVENT_MODAL, data: !!status };
}

export function toggleMyEventsDesktopModal(status: any): IAction {
  return { type: types.TOGGLE_MY_EVENTS_MODAL, data: !!status };
}

export function toggleInterestedInEventDesktopModal(status: any): IAction {
  return {
    type: types.TOGGLE_INTERESTED_IN_EVENT_DESKTOP_MODAL,
    data: !!status,
  };
}

export function toggleInterestedInUserEventDesktopModal(status: any): IAction {
  return {
    type: types.TOGGLE_INTERESTED_IN_USER_EVENT_DESKTOP_MODAL,
    data: !!status,
  };
}

export function getTimezoneSuccess(data: any): IAction {
  return { type: types.GET_TIMEZONE_SUCCESS, data };
}

export function getTimezone(): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService.getTimezone().then((res: any) => {
      if (res && res.success) {
        dispatch(getTimezoneSuccess(res.data));
      } else {
        console.log('ERROR: eventHomeAction/getTimezone', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function getClubDetail(id: any): ThunkResult<Promise<any>> {
  return () => {
    return eventService.getClubDetail(id).then((res: any) => {
      if (!res || (res && !res.success)) {
        console.log('ERROR: eventHomeAction/getTimezone', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function getClubEvents(params: any): ThunkResult<Promise<IApiResponse>> {
  return dispatch => {
    const query = {
      id: params.id,
      page: params.page || 1,
      size: params.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      type: params.type || EVENT_SELECTION_TYPE.ALL,
    };
    dispatch(
      mergeDataEvent({
        [params.type === EVENT_SELECTION_TYPE.PAST ? 'isLoadingClubPastEvt' : 'isLoadingClubEvt']: true,
      })
    );
    return eventService.getClubEvents(query).then((res: any) => {
      if (res && res.success) {
        dispatch(getClubEventsSuccess({ ...params, ...query }, res.data.data, res.data.total));
      } else {
        console.log('ERROR: eventHomeAction/getClubEvents', (res && res.message) || '');
      }
      return res;
    });
  };
}

/**
 *
 * @param params = {eventId: number, interestId: number, hasTicketAccess: boolean, userId: number}
 * @returns {function(*): *}
 */
export function showOrHiddenTicketLink(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    const { eventId, interestId, hasTicketAccess, userId } = params;
    return eventService.patchUserEventInterestTicket({ eventId, interestId, hasTicketAccess }).then((res: any) => {
      if (res && res.success) {
        dispatch(showOrHiddenTicketLinkSuccess(params));
        if (hasTicketAccess) {
          dispatch(sendEventTicketLink(eventId, userId));
        } else {
          dispatch(removeMessageShareEventTicket({ userId, eventId }));
        }
      } else {
        console.log('ERROR: eventHomeAction/patchUserEventInterestTicket', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function sendEventTicketLink(eventId: any, userId: any): ThunkResult<Promise<any>> {
  return async (dispatch, getState) => {
    let conv = getState().conversationsReducer.data.find((c: any) => c.peerVcard?.userId === userId);
    if (!conv?.id) {
      const resC = await dispatch(getOrCreateConversation(userId));
      conv = resC.success ? resC.data : undefined;
    }
    if (conv?.id) {
      const {
        data: { conversationKey, isSenderMatching, isRecvMatching, memberLevelUserLogin, receiverMemberLevel },
      } = await conversationService.getConversationStatus(userId, false);

      dispatch(
        sendShareEventMessage({
          chatType: CHAT_TYPES.CHAT,
          chatId: userId,
          event: { id: eventId, isShareTicket: true },
          isSenderMatching,
          isRecvMatching,
          recvMemberLevel: receiverMemberLevel,
          senderMemberLevel: memberLevelUserLogin,
          options: { convId: conv.id, notificationType: TYPE_INVITE },
        })
      ).then((message: any) => {
        dispatch(
          notifyMessageSent(
            userId,
            message?.body?.data ? JSON.stringify(message.body.data) : message?.body?.type,
            TYPE_MESSAGE,
            conversationKey,
            {
              messageObject: message,
            }
          )
        );
      });
    } else {
      console.error(
        'ERROR: eventHomeAction/sendEventTicketLink',
        `Can not find conversation related to event ${eventId} of user ${userId}`
      );
    }
  };
}

/**
 * @param { eventId, interestId, hasGroupChatAccess } params
 * @returns
 */
export function inviteOrRemoveGroupChat(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    // dispatch(inviteOrRemoveGroupChatSuccess(params));
    return eventService.patchUserEventInterestGroupChat(params).then((res: any) => {
      if (res && res.success) {
        dispatch(inviteOrRemoveGroupChatSuccess(params));
      } else {
        console.log('ERROR: eventHomeAction/patchUserEventInterestGroupChat', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function deleteAllUserEventInterestGroupChat(eventId: any): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService.deleteAllUserEventInterestGroupChat(eventId).then((res: any) => {
      if (res && res.success) {
        dispatch(deleteAllUserEventInterestGroupChatSuccess(eventId));
      } else {
        console.log('ERROR: eventHomeAction/deleteAllUserEventInterestGroupChat', (res && res.message) || '');
      }

      return res;
    });
  };
}

/**
 * @param {{eventId: Integer, title: String, userIds: Integer[], roomMembers: Object[], expiredAt: Number}} params
 * @returns
 */
export function postCreateGroupChat(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    const dataPost: any = {
      refObjId: params.eventId,
      subject: params.title,
      refObjType: 'event',
      coverUrl: params.coverUrl,
      expiredAt: params.expiredAt,
    };
    if (params?.groupId > 0) {
      dataPost.refObjGroupId = params.groupId;
    }
    return eventService
      .postCreateGroupChat(dataPost)
      .then((res: any) => {
        //        console.log('postCreateGroupChat', res);
        if (res.success) {
          dispatch(updateStateEventDetail({ groupChatDetail: res.data }));

          // we do not invite user direct to group chat anymore.
          // if (params.userIds && params.userIds.length > 0) {
          //   return dispatch(
          //     patchUpdateGroupChat({
          //       roomJid: res.data.roomJid,
          //       body: { userIds: params.userIds },
          //       roomMembers: params.roomMembers,
          //       users: params.users,
          //       eventId: params.eventId,
          //     })
          //   );
          // }

          // setTimeout(() => {
          dispatch(joinPrivateGroup(res.data.roomJid));
          // }, 3000);
        } else {
          console.log('ERROR: eventActions.postCreateGroupChat', res);
        }
        return res;
      })
      .catch((e: any) => {
        console.log(e);
      });
  };
}

/**
 *
 * @param {eventId} params
 * @returns
 */
export function getSearchGroupChat(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService
      .getSearchGroupChat({
        refObjId: params.eventId,
        refObjType: 'event',
      })
      .then((res: any) => {
        let groupChatDetail = null;
        if (res.success && res.data && Array.isArray(res.data) && res.data.length > 0) {
          groupChatDetail = res.data[0] || null;
          dispatch(updateStateEventDetail({ groupChatDetail }));
          if (hasOwnProperty(groupChatDetail, 'roomMembers')) {
            let { roomMembers } = groupChatDetail;
            let userIds: any[] = [];
            roomMembers.forEach((u: any) => {
              if (!u?.mainPhoto?.thumbUrl) {
                userIds.push(u.userId);
              }
            });
            if (userIds?.length > 0) {
              userService.getMainPhotos(userIds).then((res: any) => {
                if (res && res.success && Array.isArray(res.userIDs)) {
                  for (let i = 0; i < res.userIDs.length; i++) {
                    const image = res.data[i];
                    roomMembers = roomMembers.map((u: any) => {
                      const newU = { ...u };
                      if (u.userId.toString() === res.userIDs[i].toString()) {
                        newU.mainPhoto = {
                          ...image,
                        };
                      }
                      return newU;
                    });
                  }
                  console.log('updateStateGroupChat');
                  dispatch(updateStateGroupChat({ dataKey: ['roomMembers'], value: roomMembers }));
                }
              });
            }
          }
        } else {
          //  console.log('ERROR: eventService.getSearchGroupChat', res);
          dispatch(updateStateEventDetail({ groupChatDetail }));
        }
        return res;
      });
  };
}

/**
 * @param {{roomJid, body: { userIds?: Integer[], subject?: any, coverUrl: string }, roomMembers?: Object[], users?: Object[], eventId?: Integer}} params
 * @returns
 */
export function patchUpdateGroupChat(params: any): ThunkResult<Promise<any>> {
  const {
    dataDetailEvent: { groupChatDetail },
  } = myStore.getStore().getState().eventReducer;
  return (dispatch, getState) => {
    return eventService.patchUpdateGroupChat(params).then((res: any) => {
      if (res.success) {
        const { data } = res;
        const { selectedConversationInfo } = getState().conversationsReducer;
        if (params.body.subject) {
          dispatch(updateStateGroupChat({ dataKey: ['subject'], value: params.body.subject }));
        } else {
          const { roomMembers, users, eventId } = params;
          if (roomMembers) {
            const {
              userInfo: { userId },
            } = myStore.getStore().getState().loginReducer;
            const newRoom = data.roomMembers.map((u: any) => {
              const userExists = roomMembers.find((t: any) => t.userId === u.userId);
              return userExists ? { ...u, ...userExists } : u;
            });
            dispatch(updateStateGroupChat({ dataKey: ['roomMembers'], value: newRoom }));
            dispatch(updateParticipantCount({ roomJid: params.roomJid, count: newRoom.length }));

            const inActiveRoomMembers =
              groupChatDetail.inActiveRoomMembers &&
              groupChatDetail.inActiveRoomMembers.filter((us: any) => newRoom.findIndex((u: any) => u.userId === us.userId) === -1);
            dispatch(updateStateGroupChat({ dataKey: ['inActiveRoomMembers'], value: inActiveRoomMembers }));
          }

          // Update hasGroupChatAccess API RHP
          if (users) {
            // Remove from group chat (hasGroupChatAccess = true and user not in roomMembers)
            let listHasGroupChat = users.filter((u: any) => u.hasGroupChatAccess);

            const listUserShouldBeRemoved: any[] = [];
            const listUserShouldBeAdded: any[] = [];
            const promiseAll: any[] = [];
            for (let i = 0; i < listHasGroupChat.length; i++) {
              const user = listHasGroupChat[i];
              const index = roomMembers.findIndex((r: any) => r.userId === user.userId);
              if (index === -1) {
                listUserShouldBeRemoved.push(user);
                promiseAll.push(
                  dispatch(
                    inviteOrRemoveGroupChat({
                      eventId,
                      interestId: user.interestId,
                      hasGroupChatAccess: false,
                    })
                  )
                );
              }
            }
            // Invite to group chat (hasGroupChatAccess = false and user in roomMembers)
            listHasGroupChat = users.filter((u: any) => !u.hasGroupChatAccess);
            for (let i = 0; i < listHasGroupChat.length; i++) {
              const user = listHasGroupChat[i];
              const index = roomMembers.findIndex((r: any) => r.userId === user.userId && r.memberRole !== MEMBER_ROLE.OWNER);
              if (index !== -1) {
                if (!roomMembers[index].isLeft) {
                  listUserShouldBeAdded.push(user);
                }
                promiseAll.push(
                  dispatch(
                    inviteOrRemoveGroupChat({
                      eventId,
                      interestId: user.interestId,
                      hasGroupChatAccess: true,
                    })
                  )
                );
              }
            }

            // const listUserJidShouldBeAdded = listUserShouldBeAdded.map(u => {
            //   u.
            // });
            Promise.all(promiseAll).then(() => {
              if (listUserShouldBeAdded.length > 0) {
                WebIM.conn.addGroupMembers({
                  success: () => {
                    console.log('send invite message success');
                  },
                  error: (error: any) => {
                    console.log('send invite message error', error);
                  },
                  roomJid: params.roomJid,
                  list: listUserShouldBeAdded.map((u: any) => u.userId.toString()),
                  reason: REASON_INVITE_USER_TO_GROUP,
                });
              }

              if (listUserShouldBeRemoved.length > 0) {
                WebIM.conn.leaveGroup({
                  success: () => {
                    console.log('send kick-out user message success');
                  },
                  error: (error: any) => {
                    console.log('send kick-out user message error', error);
                  },
                  roomJid: params.roomJid,
                  list: listUserShouldBeRemoved.map((u: any) => u.userId.toString()),
                  reason: 'We wanna kick out you of our group chat.',
                });

                listUserShouldBeRemoved.forEach((u: any) => {
                  dispatch(
                    sendRemovedFromGroupMessage({
                      chatType: CHAT_TYPES.GROUP_CHAT,
                      chatId: params.roomJid,
                      messageData: {
                        userId: u.userId,
                        value: (u.displayName || u.userName) + ' has left the group ' + groupChatDetail.subject,
                      },
                      options: { convId: selectedConversationInfo?.id },
                    })
                  ).then((res: any) => {
                    return sentGroupMessageNotify(res, dispatch);
                  });
                });
              }
            });
          }
        }
      } else {
        console.log('ERROR: eventActions.patchUpdateGroupChat');
      }
      return res;
    });
  };
}

/**
 * @param {{ roomJid: String, user: Object }} params
 * @returns
 */
export function postAddAMemberFromGroupChat(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService
      .postAddAMemberFromGroupChat({
        roomJid: params.roomJid || -1,
        userId: (params.user && params.user.userId) || -1,
      })
      .then((res: any) => {
        if (res.success) {
          const {
            dataDetailEvent: { groupChatDetail },
          } = myStore.getStore().getState().eventReducer;
          const roomMembers = [...groupChatDetail.roomMembers, { ...params.user, isActive: true }];
          const inActiveRoomMembers =
            groupChatDetail.inActiveRoomMembers &&
            groupChatDetail.inActiveRoomMembers.filter((us: any) => us.userId !== params.user.userId);
          dispatch(updateStateGroupChat({ dataKey: ['roomMembers'], value: roomMembers }));
          dispatch(updateStateGroupChat({ dataKey: ['inActiveRoomMembers'], value: inActiveRoomMembers }));
          dispatch(updateParticipantCount({ roomJid: params.roomJid, count: roomMembers.length }));

          setTimeout(() => {
            // Set timeout because server need time to update user to group chat roomJid
            // Send without timeout can make getNewConversations return data which has not group chat roomJid
            WebIM.conn.addGroupMembers({
              success: () => {
                console.log('send invite message success');
              },
              error: (error: any) => {
                console.log('send invite message error', error);
              },
              roomJid: params.roomJid,
              list: params.user ? [params.user.userId + ''] : [],
              reason: 'We simply invite you to join us.',
            });
          }, 3000);
        } else {
          console.log('ERROR: eventActions.postAddAMemberFromGroupChat');
        }
        return res;
      });
  };
}

/**
 * @param {{roomJid: String, user: Object, subject?: String}} params
 * @returns
 */
export function postRemoveAMemberFromGroupChat(params: any): ThunkResult<Promise<any>> {
  return (dispatch, getState) => {
    return eventService
      .postRemoveAMemberFromGroupChat({
        roomJid: params.roomJid || -1,
        userId: (params.user && params.user.userId) || -1,
      })
      .then((res: any) => {
        if (res.success) {
          const { selectedConversationInfo, data } = getState().conversationsReducer;
          let convId = selectedConversationInfo?.id;
          if (!convId) {
            const conv = data.find((c: any) => c.peerVcard.userId === params?.user?.userId);
            if (conv) {
              convId = conv.id;
            }
          }
          const {
            dataDetailEvent: { groupChatDetail },
          } = myStore.getStore().getState().eventReducer;
          const roomMembers = groupChatDetail?.roomMembers || [];
          const newRoomMembers = roomMembers.filter((m: any) => m.userId !== params.user.userId);
          console.log('updateStateGroupChat');
          dispatch(updateStateGroupChat({ dataKey: ['roomMembers'], value: newRoomMembers }));
          dispatch(updateParticipantCount({ roomJid: params.roomJid, count: newRoomMembers.length }));

          WebIM.conn.leaveGroup({
            success: () => {
              console.log('send kick-out user message success');
            },
            error: (error: any) => {
              console.log('send kick-out user message error', error);
            },
            roomJid: params.roomJid,
            list: params.user ? [params.user.userId + ''] : [],
            reason: 'We wanna kick out you of our group chat.',
          });
          dispatch(
            sendRemovedFromGroupMessage({
              chatType: CHAT_TYPES.GROUP_CHAT,
              chatId: params.roomJid,
              messageData: {
                userId: params.user?.userId,
                value: (params.user?.displayName || params.user?.userName) + ' has left the group ' + params.subject,
              },
              options: { convId: convId },
            })
          ).then((res: any) => {
            return sentGroupMessageNotify(res, dispatch);
          });
        } else {
          console.log('ERROR: eventActions.postRemoveAMemberFromGroupChat');
        }
        return res;
      });
  };
}

/**
 * @param {roomJid, data} params
 * @returns
 */
export function postEndGroupChat(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService.postEndGroupChat(params).then((res: any) => {
      if (res.success) {
        dispatch(endGroupChatSuccess(params));

        WebIM.conn.destroyGroup({
          success: (msg: any) => {
            console.log('send kick-out user message success', msg);
          },
          error: (error: any) => {
            console.log('send kick-out user message error', error);
          },
          roomJid: params.roomJid,
          reason: 'I wanna destroy this group',
          name: myStore.getStore().getState().loginReducer.userInfo.userId,
        });
      } else {
        console.log('ERROR: eventActions.postEndGroupChat');
      }
      return res;
    });
  };
}

/**
 * @param {{roomJid: String, roomMembers: Array, isHistoryDeletion: Boolean default is true}} params
 * @returns
 */
export function postLeaveGroupChat(params: any): ThunkResult<Promise<any>> {
  return (dispatch, getState) => {
    const { selectedConversationInfo } = getState().conversationsReducer;
    dispatch(
      sendLeaveGroupMessage({
        chatType: CHAT_TYPES.GROUP_CHAT,
        messageType: TYPE_LEAVE_GROUP_CHAT,
        chatId: params.roomJid,
        messageData: {
          userId: params.userInfo?.userId,
          value: params.userInfo?.displayName + ' has left the group ' + params.subject,
        },
        options: { convId: selectedConversationInfo?.id },
      })
    ).then((res: any) => {
      WebIM.conn.leaveGroupBySelf({
        success: () => {
          console.log('leave group by self success');
        },
        error: (error: any) => {
          console.log('leave group by self error', error);
        },
        roomJid: params.roomJid,
        to: getState().loginReducer.userInfo.userId,
        deleteMessages: params.deleteMessages || false,
      });
      sentGroupMessageNotify(res, dispatch);
    });
    return eventService.postLeaveGroupChat(params).then((res: any) => {
      if (res.success) {
        try {
          const newRoomMembers = params.roomMembers.filter((m: any) => m.userId !== params.userInfo.userId);
          console.log('updateStateGroupChat');
          dispatch(updateStateGroupChat({ dataKey: ['roomMembers'], value: newRoomMembers }));
          dispatch(updateParticipantCount({ roomJid: params.roomJid, count: newRoomMembers.length }));
          dispatch(endGroupChatSuccess(params));
          // We're facing a case that after user left group, then join again, the messages of group still in reducer => getConversationDetails action auto add lastSyncAt value to lasted message
          // To resolve issue above, remove all messages by group roomJid
          dispatch(removeMessageByRoomJid(params.roomJid));

          // Remove roomJidsJoinedSuccess of roomJid
          getStore().dispatch(removeRoomJidInJoinedSuccessRoomJids(params.roomJid));
        } catch (e) {
          console.log(e);
        }
      } else {
        console.log('ERROR: eventActions.postLeaveGroupChat');
      }
      return res;
    });
  };
}

/**
 *
 * @param {roomJid} params
 * @returns
 */
export function getPrivateGroupChat(params: any): ThunkResult<Promise<any>> {
  return (dispatch, getState) => {
    dispatch(updateStateGroupChat({ dataKey: ['isLoading'], value: true }));
    return eventService.getPrivateGroupChat(params).then((res: any) => {
      const { userInfo } = myStore.getStore().getState().loginReducer;
      let groupChatDetail: any = {};
      if (res.success && res.data) {
        groupChatDetail = res.data || {};
        let isViewerOwner = false;
        if (res.data.sTime) {
          const time = moment(res.data.sTime).diff(moment());
          dispatch(updateServerTimeGroupChat(time));
        }
        if (hasOwnProperty(groupChatDetail, 'roomMembers')) {
          const { roomMembers } = groupChatDetail;
          const userIds = roomMembers.map((u: any) => u.userId);
          return dispatch(getMainPhotos(userIds)).then((photos: any) => {
            const userPhotos = getState().usersReducer.data;
            groupChatDetail.roomMembers = roomMembers.map((member: any) => {
              const photoIndex = userPhotos.findIndex((u: any) => u.userId === member.userId);
              return {
                ...member,
                mainPhoto: photoIndex === -1 ? {} : userPhotos[photoIndex] || {},
              };
            });
            isViewerOwner = roomMembers.findIndex((u: any) => u.userId === userInfo.userId && u.memberRole === MEMBER_ROLE.OWNER) !== -1;
            dispatch(updateStateEventDetail({ groupChatDetail, isViewerOwner }));
            return {
              success: true,
              data: {
                groupChatDetail,
              },
            };
          });
          // Check user login is Owner or not for GroupChat
        }
      } else {
        console.log('ERROR: eventService.getSearchGroupChat', res);
        dispatch(updateStateEventDetail({ groupChatDetail }));
      }
      dispatch(updateStateGroupChat({ dataKey: ['isLoading'], value: false }));

      return res;
    });
  };
}

/**
 * @param {roomJid} params
 * @returns
 */
export function postAcceptRules(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    return eventService.postAcceptRules(params).then((res: any) => {
      if (res.success) {
        dispatch(updateStateEventHome(['dataDetailEvent', 'groupChatDetail', 'isActive'], true));
        dispatch(conversationInboxAction.updateIsActivePrivateRoomConversation(params.roomJid));
      } else {
        console.log('ERROR: eventActions.postAcceptRules', res);
      }

      return res;
    });
  };
}

/**
 * @param {{ eventId, interestId }} params
 * @returns
 */
export function deleteEventInterestByOwner(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    // dispatch(deleteEventInterestByOwnerSuccess(params));
    // return Promise.resolve({ success: true });
    return eventService.deleteEventInterestByOwner(params).then((res: any) => {
      if (res.success) {
        dispatch(deleteEventInterestByOwnerSuccess(params));
      } else {
        console.log('ERROR: eventActions.deleteEventInterestByOwner', res);
      }
      return res;
    });
  };
}

export function getEventInterested(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(
      mergeDataEvent({
        isLoadingInterested: true,
      })
    );
    return eventService.getEventSearch(generateParamsEventSearch(params)).then((res: any) => {
      if (res.success) {
        dispatch(getEventInterestedSuccess(res.data, params));
      } else {
        dispatch(
          mergeDataEvent({
            isLoadingInterested: false,
          })
        );
        console.log('ERROR: eventHomeAction/getEventSearch', res.message);
      }
      return res;
    });
  };
}

export function toggleAutoSelectInterested(index: any): ThunkResult<void> {
  return dispatch => {
    dispatch(mergeDataEvent({ indexPopularSelected: index }));
  };
}

export function getCommentLikes(commentId: any, { pageNumber }: any): ThunkResult<Promise<any>> {
  return () => {
    return commentSystemServices.getCommentLikes(commentId, pageNumber).then((res: any) => {
      return res;
    });
  };
}

/**
 * @param {{ eventId: Number, memberTypes: Array, username: String, groupChatStatus: String, page: Number, size: Number, isMyEvent: Boolean }} params
 * @returns
 * @document https://tstsrvs.redhotpie.com.au/json/metadata?op=SearchUserEventInterests
 */
export function postSearchUserEventInterests(params: any): ThunkResult<Promise<any>> {
  return dispatch => {
    if (params.isMyEvent) {
      dispatch(
        mergeDataEvent({
          isLoadingUserEventInterest: true,
          pageNumberUserEventInterest: params && params.page ? params.page : 1,
          isLoadMore: params.isLoadMore || false,
        })
      );
    } else {
      dispatch(
        mergeDataEvent({
          isLoadingEventInterest: true,
          pageNumberEventInterest: params && params.page ? params.page : 1,
          isLoadMore: params.isLoadMore || false,
        })
      );
    }

    dispatch(
      mergeDataFilterInterested({
        page: params && params.page ? params.page : 1,
        isLoadingFilter: true,
      })
    );
    return eventService.postSearchUserEventInterests(params).then((res: any) => {
      if (res.success) {
        if (params.isMyEvent) {
          dispatch(getUserEventInterestSuccess(res.data, params));
        } else {
          dispatch(getEventInterestSuccess({ data: res.data, total: res.total || 0 }, params));
        }
        dispatch(
          mergeDataFilterInterested({
            isHasMore: Array.isArray(res.data) && !(res.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
            isLoadingFilter: false,
          })
        );
      } else {
        console.log('ERROR: eventAction/postSearchUserEventInterests', res.message);
      }
      return res;
    });
  };
}

export function getSuggestedUsersSuccess(data: any, paginationInfo: any): IAction {
  return { type: types.GET_EVENT_SUGGESTED_USERS_SUCCESS, data, paginationInfo };
}
export function getSuggestedUsersRequest(page: any): IAction {
  return { type: types.GET_EVENT_SUGGESTED_USERS_REQUEST, page };
}
export function updateSuggestedUserFilter(data: any): IAction {
  return { type: types.UPDATE_EVENT_SUGGESTED_USER_FILTER, data };
}
export function resetSuggestedUserFilter(): IAction {
  return { type: types.RESET_EVENT_SUGGESTED_USER_FILTER };
}

/**
 *
 * @param {{ eventId: string; pageSize?: number; page?: number }} params
 * @param {boolean} isClub
 * @returns
 */
export function getSuggestedUsers(params: any, isClub: boolean = false): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(getSuggestedUsersRequest(params.page || 1));
    if (!params.page || params?.page === 1) {
      dispatch(resetSuggestedUserFilter());
    }
    const service = isClub ? eventService.getUserClubEventSuggestedUsers : eventService.getSuggestedUsers;
    return service(params).then((res: any) => {
      if (res.success) {
        dispatch(
          getSuggestedUsersSuccess(res.data, {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: res.total,
          })
        );
      } else {
        console.log('ERROR: eventAction/getSuggestedUsers', res.message);
        dispatch(
          getSuggestedUsersSuccess([], {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: 0,
          })
        );
      }
      return res;
    });
  };
}

/**
 *
 * @param {{ memberTypes?: any; minAge?: number; maxAge?: number; location?: any; searchRadius?: number; userName?: string; pageSize?: number; page?: number }} param0
 * @returns
 */
export function searchSuggestedUsers({ params }: any): ThunkResult<Promise<any>> {
  let memberType = -1;
  if (!params.userName) {
    const activeGenders = params.memberTypes.filter((gender: any) => gender.active && gender.id > 0);
    if (activeGenders?.length > 0) {
      memberType = activeGenders.reduce((acc: any, obj: any) => acc + obj.id, 0);
    }
  }
  const state = {
    filters: {
      orderByType: '',
      minAge: params.minAge,
      maxAge: params.maxAge,
      userName: params.userName,
      location: params.location,
      searchRadius: params.searchRadius,
      memberType: memberType,
      onlineNow: false,
      withPhotos: false,
      isVerified: false,
      hasValidations: false,
      seekingMemberType: '',
    },
    checkedOrderByType: [
      {
        id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL,
        key: 'featured',
        title: 'All',
        type: 'All',
        name: 'All',
        isCheck: false,
        value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.MEMBER_LEVEL,
        nameDesktop: 'Featured',
      },
    ],
  };
  const bodyParams = { Type: 'Advanced', ...generateParamsMemberSearch(state) };
  return dispatch => {
    dispatch(updateSuggestedUserFilter({ ...params, isHasChangeFilter: !params.userName, isApplyFilter: !params.userName }));
    dispatch(getSuggestedUsersRequest(params.page || 1));
    let funcAction: Promise<any>;
    if (!!params.userName) {
      funcAction = memberSearchService.postUsersMemberSearchProfile(
        { ...bodyParams, Size: params.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH, Page: 1 },
        !!params.userName,
        false,
        false
      );
    } else {
      funcAction = params.isClubEvent
        ? eventService.getUserClubEventSuggestedUsers({
            ...params,
            pageSize: params.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            page: 1,
            memberType,
            ageMax: params.maxAge,
            ageMin: params.minAge,
          })
        : eventService.getSuggestedUsers({
            ...params,
            pageSize: params.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            page: 1,
            memberType,
            ageMax: params.maxAge,
            ageMin: params.minAge,
          });
    }
    return funcAction.then((res: any) => {
      if (res.success) {
        let data = !!params.userName ? res.data.usersSearchUserName : res.data;
        let page = (!!params.userName ? res.data.userNameSearch?.page : params.page) || 1;
        let pageSize = !!params.userName ? res.data.userNameSearch?.pageSize : params.pageSize;
        const total = !!params.userName ? 0 : res.total;
        let searchGuid = !!params.userName ? res.data.userNameSearch?.searchGuid : '';

        dispatch(getSuggestedUsersSuccess(data, { page, size: pageSize, total, searchGuid }));
      } else {
        console.log('ERROR: eventAction/searchSuggestedUsers', res.message);
        dispatch(
          getSuggestedUsersSuccess([], {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: 0,
          })
        );
      }
      return res;
    });
  };
}

/**
 *
 * @param {number} userId
 * @param {Pick<IEvent, 'id'> & { expiredAt?: number }} eventMetadata
 * @returns
 */
export function inviteUserToEvent(userId: any, eventMetadata: any): ThunkResult<Promise<any>> {
  return (dispatch, getState) => {
    const eventId = eventMetadata.id;
    return dispatch(
      createUserInvite({
        recipientUserId: userId,
        parentId: eventId,
        parentType: 'Event',
      })
    ).then(async (res: any) => {
      if (res.success && res.data) {
        const sendMessage = async () => {
          const {
            authData: { senderMemberLevel, receiverMemberLevel, isSenderMatching, isReceiverMatching },
          } = res.data;

          let conversation = getState().conversationsReducer.data.find((c: any) => c.peerVcard.userId === userId);
          if (!conversation) {
            const res = await dispatch(getOrCreateConversation(userId.toString()));
            if (res.success && res.data) {
              conversation = res.data;
            }
          }

          if (conversation) {
            const msgObj = await dispatch(
              sendShareEventMessage({
                chatType: CHAT_TYPES.CHAT,
                chatId: userId.toString(),
                event: { id: eventId },
                expts: eventMetadata.expiredAt || 0,
                senderMemberLevel: senderMemberLevel,
                recvMemberLevel: receiverMemberLevel,
                isRecvMatching: isReceiverMatching,
                isSenderMatching: isSenderMatching,
                options: {
                  convId: conversation.id,
                  notificationType: TYPE_INVITE,
                },
              })
            );

            const onMessageDeliverySuccess = (_: any, message: any) => {
              dispatch(
                notifyMessageSent(
                  message.to,
                  message?.body?.data ? JSON.stringify(message.body.data) : message?.body?.type,
                  TYPE_INVITE,
                  '',
                  {
                    messageObject: message,
                  }
                )
              );
            };

            if (WebIMConfig.isEnableStreamManagementFeature) {
              WebIMConfig.onMessageDeliverySuccess = onMessageDeliverySuccess;
            } else {
              onMessageDeliverySuccess('', msgObj);
            }
          } else {
            console.error('Can not get conversation with: ', userId);
          }
        };
        await sendMessage();
      }
      return res;
    });
  };
}

/**
 *
 * @param {{ pageSize?: number; page: number; searchGuid: string; eventId?: string, memberTypes?: any, minAge?: number, maxAge?: number }} params
 * @returns
 */
export function loadMoreSuggestedUsers(params: any, isClub: boolean = false): ThunkResult<Promise<any>> {
  return dispatch => {
    dispatch(getSuggestedUsersRequest(params.page));
    if (params.searchGuid) {
      return userService.getUsersProfileMemberSearch({ ...params, SearchGuid: params.searchGuid }).then((res: any) => {
        if (res.success) {
          dispatch(
            getSuggestedUsersSuccess(res.data.users, {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: 0,
              searchGuid: params.searchGuid,
            })
          );
        } else {
          console.log('ERROR: groupAction/loadMoreFilterSuggestedUsers', res);
          dispatch(
            getSuggestedUsersSuccess([], {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: 0,
              searchGuid: params.searchGuid,
            })
          );
        }
        return res;
      });
    } else {
      const activeGenders = params.memberTypes?.filter((gender: any) => gender.active && gender.id > 0) || [];
      let memberType = -1;
      if (activeGenders?.length > 0) {
        memberType = activeGenders.reduce((acc: any, obj: any) => acc + obj.id, 0);
      }
      const service = isClub ? eventService.getUserClubEventSuggestedUsers : eventService.getSuggestedUsers;
      return service({ ...params, memberType, ageMax: params.maxAge, ageMin: params.minAge }).then((res: any) => {
        if (res.success) {
          dispatch(
            getSuggestedUsersSuccess(res.data, {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: res.total,
            })
          );
        } else {
          console.log('ERROR: groupAction/loadMoreFilterSuggestedUsers', res);
          dispatch(
            getSuggestedUsersSuccess([], {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: 0,
            })
          );
        }
        return res;
      });
    }
  };
}

/**
 *
 * @param {number} userId
 * @param {{roomJid: string, value: string, roomId: number, expiredAt?: number, eventId: number}} groupChatMetadata
 */
export function sendInviteUserToGroupChatMessage(userId: any, groupChatMetadata: any): ThunkResult<Promise<any>> {
  return (dispatch, getState) => {
    return dispatch(createUserInvite({ recipientUserId: userId, parentType: 'GroupChat', parentId: groupChatMetadata.eventId })).then(
      async (res: any) => {
        console.log('res', res);
        if (res.success && res.data) {
          const sendMessage = async () => {
            const {
              authData: { senderMemberLevel, receiverMemberLevel, isSenderMatching, isReceiverMatching },
            } = res.data;

            let conversation = getState().conversationsReducer.data.find((c: any) => c.peerVcard.userId === userId);
            if (!conversation) {
              const res = await dispatch(getOrCreateConversation(userId.toString()));
              if (res.success && res.data) {
                conversation = res.data;
              }
            }

            if (conversation) {
              const msgObj = await dispatch(
                sendInviteGroupChatMessage({
                  chatType: CHAT_TYPES.CHAT,
                  chatId: userId.toString(),
                  group: {
                    roomJid: groupChatMetadata.roomJid,
                    value: groupChatMetadata.value,
                  },
                  expts: groupChatMetadata.expiredAt || 0,
                  senderMemberLevel: senderMemberLevel,
                  recvMemberLevel: receiverMemberLevel,
                  isRecvMatching: isReceiverMatching,
                  isSenderMatching: isSenderMatching,
                  options: {
                    convId: conversation.id,
                    notificationType: TYPE_INVITE,
                  },
                })
              );

              const onMessageDeliverySuccess = (_: any, message: any) => {
                dispatch(
                  notifyMessageSent(
                    message.to,
                    message?.body?.data ? JSON.stringify(message.body.data) : message?.body?.type,
                    TYPE_INVITE,
                    '',
                    {
                      messageObject: message,
                    }
                  )
                );
              };

              if (WebIMConfig.isEnableStreamManagementFeature) {
                WebIMConfig.onMessageDeliverySuccess = onMessageDeliverySuccess;
              } else {
                onMessageDeliverySuccess('', msgObj);
              }
            } else {
              console.error('Can not get conversation with: ', userId);
            }
          };
          await sendMessage();
        }
        return res;
      }
    );
  };
}
